export default __webpack_public_path__ + "static/apple-touch-icon-120x120-c96a5887e1dd7cf0fdc791720d04af3d.png";